export type { PaginationProps } from './Pagination';
export { default as Pagination } from './Pagination';
